'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _CartStore = require('../../stores/CartStore.jsx');

var _CartStore2 = _interopRequireDefault(_CartStore);

var _reflux = require('reflux');

var _reflux2 = _interopRequireDefault(_reflux);

var _Utility = require('../../utils/Utility.jsx');

var Utils = _interopRequireWildcard(_Utility);

var _Actions = require('../../Actions.jsx');

var _Actions2 = _interopRequireDefault(_Actions);

var _Address = require('../account/Address.jsx');

var _Address2 = _interopRequireDefault(_Address);

var _AddressList = require('./address/AddressList.jsx');

var _AddressList2 = _interopRequireDefault(_AddressList);

var _parse = require('parse');

var _parse2 = _interopRequireDefault(_parse);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _CurbsidePickupAddressView = require('./CurbsidePickupAddressView.jsx');

var _CurbsidePickupAddressView2 = _interopRequireDefault(_CurbsidePickupAddressView);

var _TabPane = require('../generic/TabPane.js');

var _TabPane2 = _interopRequireDefault(_TabPane);

var _MainStore = require('../../stores/MainStore.jsx');

var _MainStore2 = _interopRequireDefault(_MainStore);

var _Utility2 = require('../../utils/Utility');

var Utility = _interopRequireWildcard(_Utility2);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PICKUP_NOT_AVAILABLE_MSG = "Delivery only. Pick Up is not available.";

var PickupAddressView = function (_React$Component) {
    _inherits(PickupAddressView, _React$Component);

    function PickupAddressView(props) {
        _classCallCheck(this, PickupAddressView);

        var _this = _possibleConstructorReturn(this, (PickupAddressView.__proto__ || Object.getPrototypeOf(PickupAddressView)).call(this, props));

        _this.clickedPickUpLocation = function (e) {

            var pickUpLocationSelected = e.target.checked;

            _this.setState({
                isPickUpLocationSelected: pickUpLocationSelected
            }, function () {
                _this.handleCallBackToParent();
            });
        };

        _this.state = {
            orderType: "",
            isCurbsidePickup: false,
            isPickUpLocationSelected: false
        };
        return _this;
    }

    _createClass(PickupAddressView, [{
        key: 'UNSAFE_componentWillMount',
        value: function UNSAFE_componentWillMount() {
            var _this2 = this;

            var isCurbsidePickup = this.state.isCurbsidePickup;

            this.setState({
                orderType: "PickUp",
                isCurbsidePickup: _CartStore2.default.isLocationCurbsidePickupEnabled(),
                isPickUpLocationSelected: _CartStore2.default.getIsPickUpLocationSelected()
            }, function () {
                if (!_this2.state.isCurbsidePickup) {
                    _this2.handleCallBackToParent();
                }
            });
        }
    }, {
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(nextProps) {

            if (!Utils.isEmptyObj(nextProps.curbSideObj)) {
                var pickUpLocationSelected = nextProps.curbSideObj.isPickUpLocationSelected;

                this.setState({
                    isPickUpLocationSelected: pickUpLocationSelected
                });
            }
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.setState({
                orderType: "PickUp"
            }, function () {
                // Actions
                //     .addDeliveryAddress
                // (this.props.scheduleScreenStore.scheduleScreenUpdatedObject.orderType, null, -1);
            });
        }
    }, {
        key: 'handleCallBackToParent',
        value: function handleCallBackToParent() {
            var isPickUpLocationSelected = this.state.isPickUpLocationSelected;

            var obj = {
                vMakeModel: "",
                vColor: "",
                isPreferCurbside: false,
                isPickUpLocationSelected: isPickUpLocationSelected
            };

            this.props.handleCurbSideChange(obj);
        }
    }, {
        key: 'renderPickUpAddress',
        value: function renderPickUpAddress() {
            var address = "";
            var locationDetail = _MainStore2.default.getActiveLocation();
            if (!Utility.isEmptyObj(locationDetail)) {
                // Location name
                var addressString1 = locationDetail.addLine1;
                // Address
                var addressString2 = locationDetail.city + ', ' + locationDetail.state + ' ' + locationDetail.zipCode;
                address = addressString1 + ", " + addressString2;
            }

            return _react2.default.createElement(
                'div',
                { className: 'form-group mb-2 mt-1 cart-checkout ' },
                _react2.default.createElement('i', { className: 'icofont-location-pin' }),
                ' ',
                address
            )
            // <p className={"text-primary"}>{address}</p>
            ;
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: 'panel-default panel-border-less cart-box' },
                this.state.isCurbsidePickup ? _react2.default.createElement(_CurbsidePickupAddressView2.default
                // callbackParent={this.props.callbackParent}
                , { handleCurbSideChange: this.props.handleCurbSideChange,
                    curbSideObj: this.props.curbSideObj
                }) : this.renderPickUpAddress(),
                _react2.default.createElement('span', { className: 'col-12 cart_border d-inline-block' })
            );
        }
    }]);

    return PickupAddressView;
}(_react2.default.Component);

exports.default = PickupAddressView;


//////////////////
// WEBPACK FOOTER
// ./src/components/schedule/PickupAddressView.jsx
// module id = 494
// module chunks = 0